var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSquareUpRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 -0.5 28 28",
    stroke: "currentColor",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M17 16v-6m0 0h-6m6 0l-6 6m-1.2 6h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 001.311-1.311C23 19.72 23 18.88 23 17.2V8.8c0-1.68 0-2.52-.327-3.162a3 3 0 00-1.311-1.311C20.72 4 19.88 4 18.2 4H9.8c-1.68 0-2.52 0-3.162.327a3 3 0 00-1.311 1.311C5 6.28 5 7.12 5 8.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 001.311 1.311C7.28 22 8.12 22 9.8 22z"
  })));
}
export default __webpack_public_path__ + "static/media/square-up-right.c036a727.svg";
export { SvgSquareUpRight as ReactComponent };